export default __webpack_public_path__ + "static/media/logo.f0986522.png";